module.exports = __webpack_public_path__ + "7b4aa366d432a02b04463eb65b77f140.pdf";